import { MoveGenerator } from '../../jscaip/AI/AI';
import { Player } from '../../jscaip/Player';
import { ApagosMove } from './ApagosMove';
import { ApagosRules } from './ApagosRules';
export class ApagosMoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        const state = node.gameState;
        const moves = [];
        for (let x = 0; x < config.width; x++) {
            moves.push(ApagosMove.drop(x, Player.ZERO));
            moves.push(ApagosMove.drop(x, Player.ONE));
            for (let smallerX = 0; smallerX < x; smallerX++) {
                moves.push(ApagosMove.transfer(x, smallerX).get());
            }
        }
        function isLegal(move) {
            return ApagosRules.get().isLegal(move, state).isSuccess();
        }
        return moves.filter(isLegal);
    }
}
